/**
 * Supabase error breadcrumbs, decoupled from Sentry.
 *
 * base-supabase-service also runs in the API Worker, where Sentry is never
 * initialised - importing any @sentry/* package there is pure bundle weight.
 * The browser installs the real sink alongside Sentry's `init`; everywhere else
 * this stays a no-op.
 */
export type SupabaseErrorBreadcrumb = {
  message: string;
  level: "error";
  data: { details: string };
};

let sink: (breadcrumb: SupabaseErrorBreadcrumb) => void = () => {};

export function setSupabaseBreadcrumbSink(
  next: (breadcrumb: SupabaseErrorBreadcrumb) => void,
): void {
  sink = next;
}

export function addSupabaseBreadcrumb(breadcrumb: SupabaseErrorBreadcrumb): void {
  sink(breadcrumb);
}
